module.exports = __webpack_public_path__ + "img/servinga.4273bb67.svg";